import EntityType from '@/shared/enums/EntityType';
import { EntityName, EntityPluralName } from '@enums/EntityName';
import MetricProperty from '@enums/MetricProperty';
import { EntityMetric } from '@/lib/enums';

export default function getCountLabel(entityType, count) {
  switch (entityType) {
    case EntityType.SKILL:
    case EntityType.SKILL_LEVEL:
    case EntityType.PROPERTY:
    case EntityType.PROPERTY_VALUE:
      return MetricProperty[EntityMetric.COUNT].label.singular;
    default:
      return count === 1
        ? EntityName[entityType]
        : EntityPluralName[entityType];
  }
}
